import { useState } from "react";
import { FaJava, FaNodeJs, FaReact } from "react-icons/fa";
import { SiCapacitor, SiCsharp, SiMongodb, SiNextdotjs, SiPostgresql, SiSupabase, SiTailwindcss, SiTypescript } from "react-icons/si";
import { useTranslation } from "react-i18next";

export default function Skills() {
    const { t } = useTranslation();
    return (
        <div className="flex flex-col items-center gap-3 md:gap-8">
            <div className="flex flex-wrap justify-center gap-4 md:gap-10">
                <Skill name="React.js"><FaReact className="w-7 h-7 md:w-12 md:h-12" /></Skill>
                <Skill name="Next.js"><SiNextdotjs className="w-7 h-7 md:w-12 md:h-12" /></Skill>
                <Skill name="TypeScript"><SiTypescript className="w-7 h-7 md:w-12 md:h-12" /></Skill>
                <Skill name="Node.js"><FaNodeJs className="w-7 h-7 md:w-12 md:h-12" /></Skill>
                <Skill name="Supabase"><SiSupabase className="w-7 h-7 md:w-12 md:h-12" /></Skill>
                <Skill name="PostgreSQL"><SiPostgresql className="w-7 h-7 md:w-12 md:h-12" /></Skill>
                <Skill name="Capacitor"><SiCapacitor className="w-7 h-7 md:w-12 md:h-12" /></Skill>
                <Skill name="TailwindCSS"><SiTailwindcss className="w-7 h-7 md:w-12 md:h-12" /></Skill>
                <Skill name="C#"><SiCsharp className="w-7 h-7 md:w-12 md:h-12" /></Skill>
            </div>
            <div className="flex flex-col items-center gap-2 md:gap-3">
                <span className="text-xs font-semibold uppercase tracking-widest opacity-50">{t("skillsSecondaryLabel")}</span>
                <div className="flex flex-wrap justify-center gap-4 md:gap-8">
                    <Skill name="Java" below><FaJava className="w-5 h-5 md:w-8 md:h-8 opacity-50" /></Skill>
                    <Skill name="MongoDB" below><SiMongodb className="w-5 h-5 md:w-8 md:h-8 opacity-50" /></Skill>
                </div>
            </div>
        </div>
    );
}

interface SkillProps {
    name: string;
    below?: boolean;
    children: React.ReactNode;
}

function Skill(props: SkillProps) {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className="flex justify-center" onClick={() => setShowTooltip(!showTooltip)} onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
            <div aria-hidden="true" className={`${showTooltip ? "visible" : "invisible"} absolute ${props.below ? "mt-7 md:mt-11" : "-mt-8"} text-primary`}>
                <div className={`${props.below ? "tooltip-below" : "tooltip"} bg-darkBlue text-white px-2 py-1 text-sm rounded-md`}>{props.name}</div>
            </div>
            <span role="img" aria-label={props.name} className="flex">{props.children}</span>
        </div>
    );
}
